import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-category-page-three',
  templateUrl: './category-page-three.component.html',
  styleUrls: ['./category-page-three.component.scss']
})
export class CategoryPageThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
